/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';

export interface GenerateConsentUrlRequest {
    customerTenantId: string;
    enterpriseAppId?: string;
    sessionId?: string;
}

export interface HandleConsentCallbackRequest {
    tenant?: string;
    adminConsent?: string;
    error?: string;
    errorDescription?: string;
    sessionId?: string;
}

export interface ListAvailableEnterpriseAppsRequest {
    sessionId?: string;
    targetTenantId?: string;
}

export interface ValidateConsentStatusRequest {
    customerTenantId: string;
    enterpriseAppId?: string;
    sessionId?: string;
}

/**
 * IntegrationsConsentApi - interface
 * 
 * @export
 * @interface IntegrationsConsentApiInterface
 */
export interface IntegrationsConsentApiInterface {
    /**
     * Generates Azure AD admin consent URL for customer tenant using Enterprise App configuration
     * @summary Generate consent URL
     * @param {string} customerTenantId Customer Azure AD tenant ID
     * @param {string} [enterpriseAppId] Optional Enterprise App configuration ID to use a specific EA
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsConsentApiInterface
     */
    generateConsentUrlRaw(requestParameters: GenerateConsentUrlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Generates Azure AD admin consent URL for customer tenant using Enterprise App configuration
     * Generate consent URL
     */
    generateConsentUrl(requestParameters: GenerateConsentUrlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Processes the callback from Azure AD admin consent flow
     * @summary Handle Azure AD consent callback
     * @param {string} [tenant] Azure AD tenant ID
     * @param {string} [adminConsent] Whether admin consent was granted
     * @param {string} [error] Error code if consent failed
     * @param {string} [errorDescription] Error description if consent failed
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsConsentApiInterface
     */
    handleConsentCallbackRaw(requestParameters: HandleConsentCallbackRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Processes the callback from Azure AD admin consent flow
     * Handle Azure AD consent callback
     */
    handleConsentCallback(requestParameters: HandleConsentCallbackRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Lists Enterprise Applications available to the current tenant for use in integration wizards
     * @summary List available Enterprise Applications
     * @param {string} [sessionId] Session ID for authorization
     * @param {string} [targetTenantId] Optional target tenant ID for cross-tenant context (e.g. when installing for a specific tenant)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsConsentApiInterface
     */
    listAvailableEnterpriseAppsRaw(requestParameters: ListAvailableEnterpriseAppsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Lists Enterprise Applications available to the current tenant for use in integration wizards
     * List available Enterprise Applications
     */
    listAvailableEnterpriseApps(requestParameters: ListAvailableEnterpriseAppsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Validates if admin consent is still active for the enterprise application
     * @summary Validate consent status
     * @param {string} customerTenantId Customer Azure AD tenant ID
     * @param {string} [enterpriseAppId] Optional Enterprise App configuration ID to use a specific EA
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsConsentApiInterface
     */
    validateConsentStatusRaw(requestParameters: ValidateConsentStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Validates if admin consent is still active for the enterprise application
     * Validate consent status
     */
    validateConsentStatus(requestParameters: ValidateConsentStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

}

/**
 * 
 */
export class IntegrationsConsentApi extends runtime.BaseAPI implements IntegrationsConsentApiInterface {

    /**
     * Generates Azure AD admin consent URL for customer tenant using Enterprise App configuration
     * Generate consent URL
     */
    async generateConsentUrlRaw(requestParameters: GenerateConsentUrlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['customerTenantId'] == null) {
            throw new runtime.RequiredError(
                'customerTenantId',
                'Required parameter "customerTenantId" was null or undefined when calling generateConsentUrl().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['customerTenantId'] != null) {
            queryParameters['customerTenantId'] = requestParameters['customerTenantId'];
        }

        if (requestParameters['enterpriseAppId'] != null) {
            queryParameters['enterpriseAppId'] = requestParameters['enterpriseAppId'];
        }

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/integrations/consent/url`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Generates Azure AD admin consent URL for customer tenant using Enterprise App configuration
     * Generate consent URL
     */
    async generateConsentUrl(requestParameters: GenerateConsentUrlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.generateConsentUrlRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Processes the callback from Azure AD admin consent flow
     * Handle Azure AD consent callback
     */
    async handleConsentCallbackRaw(requestParameters: HandleConsentCallbackRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        if (requestParameters['tenant'] != null) {
            queryParameters['tenant'] = requestParameters['tenant'];
        }

        if (requestParameters['adminConsent'] != null) {
            queryParameters['admin_consent'] = requestParameters['adminConsent'];
        }

        if (requestParameters['error'] != null) {
            queryParameters['error'] = requestParameters['error'];
        }

        if (requestParameters['errorDescription'] != null) {
            queryParameters['error_description'] = requestParameters['errorDescription'];
        }

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/integrations/consent/callback`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Processes the callback from Azure AD admin consent flow
     * Handle Azure AD consent callback
     */
    async handleConsentCallback(requestParameters: HandleConsentCallbackRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.handleConsentCallbackRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Lists Enterprise Applications available to the current tenant for use in integration wizards
     * List available Enterprise Applications
     */
    async listAvailableEnterpriseAppsRaw(requestParameters: ListAvailableEnterpriseAppsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        if (requestParameters['targetTenantId'] != null) {
            queryParameters['targetTenantId'] = requestParameters['targetTenantId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/integrations/consent/enterprise-apps`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Lists Enterprise Applications available to the current tenant for use in integration wizards
     * List available Enterprise Applications
     */
    async listAvailableEnterpriseApps(requestParameters: ListAvailableEnterpriseAppsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.listAvailableEnterpriseAppsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Validates if admin consent is still active for the enterprise application
     * Validate consent status
     */
    async validateConsentStatusRaw(requestParameters: ValidateConsentStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['customerTenantId'] == null) {
            throw new runtime.RequiredError(
                'customerTenantId',
                'Required parameter "customerTenantId" was null or undefined when calling validateConsentStatus().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['customerTenantId'] != null) {
            queryParameters['customerTenantId'] = requestParameters['customerTenantId'];
        }

        if (requestParameters['enterpriseAppId'] != null) {
            queryParameters['enterpriseAppId'] = requestParameters['enterpriseAppId'];
        }

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/integrations/consent/validate`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Validates if admin consent is still active for the enterprise application
     * Validate consent status
     */
    async validateConsentStatus(requestParameters: ValidateConsentStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.validateConsentStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
